import { Form } from "antd";
import { Modal } from "../../../../../common/components/modal/modal";
import { RecruiterGoalsForm } from "./recruiterGoalsForm";

export const CreateGoalsModal = ({
  open,
  loading,
  onFinish,
  availableClients,
  closeModal,
  ...props
}) => {
  const [form] = Form.useForm();

  return (
    <Modal
      open={open}
      onCancel={closeModal}
      title="Create Recruiter Goals"
      className="modal-overflow-auto s2-theme-style"
      onOk={form.submit}
      okButtonProps={{ loading }}
      {...props}
    >
      <RecruiterGoalsForm
        form={form}
        onFinish={onFinish}
        clients={availableClients}
      />
    </Modal>
  );
};
